export const DROPDOWN_USER_NAME = "Serhat Özbalcıoğlu";
export const DROPDOWN_SWITCH_ACCOUNT = "Hesap Değiştir";
export const DROPDOWN_LANGUAGE = "Türkçe";
export const DROPDOWN_LOGOUT = "Çıkış";
